// NOTE:
// This is the place to be to create commands to send to ROW2, opened in another tab.
// This DOES NOT work, and is not intended, for ROW2 opened in the FilingCabinet of the React container!
// This file is a recreation of the original localStorage event system.

// If you want to also make this work for more "events" when the external ROW2 is NOT opened, check FilingCabinet.js in ROW2 and search for "URLSearchParams"
// An implementation based on the url parameters is done there.

const checkROW2Link = (path: string): boolean => {
    const row2Open = localStorage.getItem('row2Open') != null;
    if (!row2Open) {
        return false;
    }

    const urlData = new URL(window.location.origin + path);

    if (/PlacerlistForPatient/.exec(path)) {
        const data = {
            command: 'openPlacerList',
            data: {
                InternalID: urlData.searchParams.get('ID'),
                DOB: urlData.searchParams.get('DOB'),
                Name: urlData.searchParams.get('Name'),
            },
        };
        localStorage.removeItem('row1Message');
        localStorage.setItem('row1Message', JSON.stringify(data));
    }
    else if (/Appointment/.exec(path)) {
        const data = {
            command: 'openAppointment',
            data: {
                AppointmentID: urlData.searchParams.get('ID'),
            },
        };
        localStorage.removeItem('row1Message');
        localStorage.setItem('row1Message', JSON.stringify(data));
    }
    else {
        return false;
    }

    return true;
};

export default checkROW2Link;
